import { z } from "zod";

export const HealthResponse = z.object({
  ok: z.literal(true),
  region: z.string(),
  stage: z.string(),
  version: z.string(),
  time: z.iso.datetime(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;

export const HealthError = z.object({
  ok: z.literal(false),
  error: z.string(),
});
export type HealthError = z.infer<typeof HealthError>;
